import { AgxButton, Icon_Arrow } from '@urbanx/agx.ui-components2';
import { Pages } from 'constants/menu';
import { useNavigate } from 'react-router-dom';

const SupportBackButton = () => {
  const navigate = useNavigate();

  return (
    <AgxButton
      id="back-to-support-button"
      text="Support"
      variant="naked"
      size="small"
      leftIcon={<Icon_Arrow direction="left" width={16} height={16} />}
      onClick={() => navigate(`/${Pages.SUPPORT}`)}
    />
  );
};

export default SupportBackButton;
